module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "epi-brk",
    attrs: {
      "id": "epi"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "ep"
  }, [_c('span', {
    staticClass: "epub-i"
  }, [_vm._v("There never was a man who holding pain within himself had not seen God and known eternity and walked from them alone … or else, seeing beauty, thirsted after it as some life-giving force to which he must give his whole abandon.")])]), _vm._v(" "), _c('p', {
    staticClass: "epc"
  }, [_c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("—")]), _vm._v("M"), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("ILLICENT ")]), _vm._v("R"), _c('span', {
    staticClass: "epub-sc"
  }, [_vm._v("OGERS")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0825b0b2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/epigraph.vue
// module id = 72
// module chunks = 0